export enum QueryParams {
  Flow = 'flow',
  Lang = 'lang'
}
